 document.addEventListener('DOMContentLoaded', function() {
  /* portfolio section home page hover to show description - Start */

  function enableDesktopProfileHover() {
  if (window.innerWidth < 1024) return; // Mobile/tablet skip

  document.querySelectorAll('.profile details').forEach((details) => {
    const summary = details.querySelector('summary');

    summary.addEventListener('mouseenter', () => {
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });

    details.addEventListener('mouseleave', () => {
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
      }
    });
  });
}

enableDesktopProfileHover();

// Re-run on resize (optional)
window.addEventListener('resize', () => {
  enableDesktopProfileHover();
});

  /* portfolio section home page hover to show description - End */

/* Collection page multi column Sticky section*/
// window.addEventListener('scroll', function () {
//   const targetElement = document.querySelector('.grid.slider.slider--tablet.z21-multicolumn-5');
//   const section = targetElement ? targetElement.closest('.section--padding') : null;
//   const header = document.querySelector('.header--center-left, .mobile\\:header--left');
//   const footer = document.querySelector('footer'); 

//   if (!targetElement || !section) return;

//   const headerHeight = header ? header.offsetHeight : 0;
//   const footerHeight = footer ? footer.offsetHeight : 0;
//   const sectionRect = section.getBoundingClientRect();
//   const footerRect = footer ? footer.getBoundingClientRect() : null;

//   const stickyHeight = targetElement.offsetHeight;
//   const isMobile = window.innerWidth <= 768;

//   const mobileOffsetBuffer = isMobile ? 80 : 0;

//   const footerOverlap =
//     footerRect && footerRect.top <= stickyHeight + headerHeight + mobileOffsetBuffer;

//   const shouldStick =
//     sectionRect.top <= headerHeight &&
//     (!footerRect || footerRect.top > stickyHeight + headerHeight + mobileOffsetBuffer);

//   if (shouldStick) {
//     targetElement.classList.add('fixed');
//     targetElement.style.position = 'fixed';
//     targetElement.style.top = `${headerHeight}px`;
//     targetElement.style.bottom = 'auto';
//   } else if (footerOverlap) {
//     targetElement.classList.remove('fixed');
//     targetElement.style.position = 'absolute';
//     targetElement.style.width = '100%';
//   } else {
//     targetElement.classList.remove('fixed');
//     targetElement.style.position = '';
//   }
// });
 
/* End Collection page multi column Sticky section*/

/* Multi Block Click Functionality on mobile */
  if (window.innerWidth <= 768) {
    const mediaCards = document.querySelectorAll('.Multi-blocks-wrapper .media-card--overlap');
    
    mediaCards.forEach(card => {
      const plusButton = card.querySelector('.multi_block__button');
      
      // Handle click only on the + button
      if (plusButton) {
        plusButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Close all other cards
          mediaCards.forEach(otherCard => {
            if (otherCard !== card) {
              otherCard.classList.remove('active');
            }
          });
          
          // Toggle current card
          card.classList.toggle('active');
        });
      }
    });
    
    // Close card when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.Multi-blocks-wrapper .media-card--overlap')) {
        mediaCards.forEach(card => {
          card.classList.remove('active');
        });
      }
    });
  }
});
/* End Multi Block Click Functionality on moobile */

/* Popup product martket ID */
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-id-popup-trigger]');

  triggers.forEach((trigger) => {
    const wrapper = trigger.parentElement;

    const popup =
      wrapper.querySelector('.id-market-popup') ||
      document.querySelector('.id-market-popup');

    if (!popup) return;

    const confirmButton = popup.querySelector('[data-id-popup-confirm]');
    const closeButtons = popup.querySelectorAll('[data-id-popup-close]');
    const countdownEl = popup.querySelector('[data-id-popup-countdown]');

    let countdownTimer = null;

    const clearCountdown = () => {
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    };

    const closePopup = () => {
      clearCountdown();

      popup.hidden = true;
      document.documentElement.classList.remove('popup-open');
      document.body.classList.remove('popup-open');
    };

    const startCountdown = () => {
      clearCountdown();

      let seconds = 10;

      if (countdownEl) {
        countdownEl.textContent = seconds;
      }

      countdownTimer = setInterval(() => {
        seconds -= 1;

        if (countdownEl) {
          countdownEl.textContent = seconds;
        }

        if (seconds <= 0) {
          clearCountdown();

          if (countdownEl) {
            countdownEl.textContent = '0';
          }

          // Jangan auto redirect
          // Jangan close popup
        }
      }, 1000);
    };

    trigger.addEventListener('click', () => {
      const externalLink = trigger.dataset.externalLink;

      if (confirmButton && externalLink) {
        confirmButton.setAttribute('href', externalLink);
      }

      popup.hidden = false;
      document.documentElement.classList.add('popup-open');
      document.body.classList.add('popup-open');

      startCountdown();
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', closePopup);
    });

    if (confirmButton) {
      confirmButton.addEventListener('click', () => {
        closePopup();
      });
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
    // Check if URL has the hash on page load
    if (window.location.hash === '#find-my-shade') {
      const target = document.getElementById('shopify-section-template--23515809808661__1786034226508c4813');
      if (target) {
        setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500); // delay to let page fully render
      }
    }
  });
/* End popup product market ID */
